import IconButton from "components/elements/IconButton";
import MonthInput from "components/elements/MonthInput";
import dataProvider from "core/DataProvider";
import { useState } from "react";
import toast from "react-hot-toast";

const getDefaultPeriodFrom = () => {
  let dt = new Date();

  if (dt.getMonth() < 5) {
    dt.setYear(dt.getFullYear() - 1);
  }

  dt.setMonth(3);

  let parts = dt.toISOString().split("T")[0].split("-");
  return `${parts[0]}-${parts[1]}`;
};

const getDefaultPeriodTo = () => {
  let dt = new Date();
  // dt.setDate(0);
  dt.setMonth(dt.getMonth() - 1);

  let parts = dt.toISOString().split("T")[0].split("-");
  return `${parts[0]}-${parts[1]}`;
};

const customDateFormat = date => {
  let returnDate = date;

  if (typeof returnDate === "string") {
    try {
      returnDate = new Date(returnDate);
    } catch (error) {
      console.warn(`Invalid date passed to formatDate`);
      return returnDate;
    }
  }

  try {
    returnDate = new Intl.DateTimeFormat("en-US", {
      year: "numeric",
      month: "short",
    }).format(returnDate);
  } catch (error) {
    console.warn(`Invalid date passed to formatDate`);
  }

  return returnDate;
};

const BillingRequest = props => {
  const [loading, setLoading] = useState(false);
  const [formVisible, setFormVisible] = useState(false);
  const [billingFrom, setBillingFrom] = useState(getDefaultPeriodFrom());
  const [billingMonth, setBillingMonth] = useState(getDefaultPeriodTo());

  const submit = async () => {
    setLoading(true);
    try {
      await dataProvider.network.post("billing/request", {
        billing_from: billingFrom,
        billing_to: billingMonth,
      });
      toast.success(
        "Your request is submitted, bills will be processed in 15 minutes",
        {
          duration: 5000,
        }
      );
      props.onComplete();
    } catch (error) {
      toast.error("Failed to generate bills");
      if (error.response.data && error.response.data.error) {
        toast.error(error.response.data.error);
      }
    } finally {
      setFormVisible(false);
      setLoading(false);
    }
  };

  return (
    <div className="billing-request">
      <div className="flex">
        <div className="flex right flex-v-center">
          {formVisible ? (
            loading ? (
              <div className="loader">
                <div className="lds-hourglass"></div>
              </div>
            ) : (
              <>
                <IconButton text="Generate Bill" onClick={submit} />
                <IconButton
                  text="Cancel"
                  onClick={() => {
                    setFormVisible(false);
                  }}
                />
              </>
            )
          ) : (
            <IconButton
              icon="add"
              text="New Request"
              onClick={() => setFormVisible(true)}
            />
          )}
        </div>
      </div>
      {formVisible && (
        <div className="box mtop">
          <div className="flex flex-v-center pad-lr">
            <h3>New Billing Request</h3>
            <div className="flex flex-full" style={{ justifyContent: "end" }}>
              <div className="el" style={{ minWidth: "300px" }}>
                <MonthInput
                  value={billingFrom}
                  onChange={val => setBillingFrom(val)}
                  placeholder="Calculate Billing From"
                  customFormat={customDateFormat}
                />
              </div>
              <div className="el" style={{ minWidth: "300px" }}>
                <MonthInput
                  value={billingMonth}
                  onChange={val => setBillingMonth(val)}
                  placeholder="Generate Billing For"
                  customFormat={customDateFormat}
                />
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default BillingRequest;
